import React, { Component } from "react";
import { QuestionTable } from '@learningblocks/storybook-components';
import { findIndex } from 'lodash'

export class QuestionTableAdapter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      //datas: null,
      //totalAttempts: 3,
      submitDisabled: true,
      predictedAnswers: ['', '', '',],
      errorMessage: [],
      feedbackType: null
    };
  }

  onSubmitChanges = (componentId) => {
    this.props.data.forEach((row, rowIndex) => {
      row.forEach((cell, cellIndex) => {
        if(cell.hasOwnProperty('linkedField')){
          if(cell.options.hasOwnProperty(cell.value)){
            this.props.questionTableCellUpdateResults({
              id: (cell.linkedField.rowId - 1) + "_" + (cell.linkedField.cellId - 1),
              value: cell.options[cell.value].label,
              answer: null
            })
          }
        }
      })
    })

    this.props.questionTableSubmit(componentId);
    //this.props.setPredtictedQuestionTableData({ predtictedQuestionTableData })

    // check if all fields are filled and are correct
    
    if (!this.isComplete(this.props.data)) {
      this.setState({ feedbackType: this.props.isProtocolQuestionTable ? 'INCOMPLETE_PROTOCOL_QUESTION_TABLE' :  'INCOMPLETE_QUESTION_TABLE'})
      return
    }

    if (this.isCorrect(this.props.data)) {
      if(!this.hasInputFeedback(this.props.data)){
        this.setState({ feedbackType: this.props.isProtocolQuestionTable ? 'CORRECT_PROTOCOL_QUESTION_TABLE' :  'CORRECT_QUESTION_TABLE'})
      } else {
        this.setState({
          feedbackType: null,
          errorMessage: []
        })
      }
      return
    }
    
    this.setState({ feedbackType: this.props.isProtocolQuestionTable ? 
          (this.props.level === 1 ?
          'INCORRECT_PROTOCOL_QUESTION_TABLE'  :   'INCORRECT_PROTOCOL_QUESTION_TABLE_2') 
          :  'INCORRECT_QUESTION_TABLE'})
  }

  isComplete = (questionTableData) => {
    if (!questionTableData) {
      return false;
    }
    for (let i of questionTableData) {
      for (let j of i) {
        if (j.type === 'INPUT') {
          if (j.value.length < 1) {
            return false
          }
        }
        if(j.type === 'DROPDOWN'){
          if (j.value === null) {
            return false
          }
        }
      }
    }
    return true
  }

  isCorrect = (questionTableData) => {
    const errors = []
    for (let i of questionTableData) {
      for (let j of i) {
        if (j.type === 'INPUT') {
          let value = Number(j.value);
          let correctValue = Number(j.correctValue)
          if (value && value !== correctValue) {
            errors.push(j.errorMessage)
          }
        }
      }
    }

    if (errors.length > 0) {
      this.setState({ errorMessage: errors })
      return false
    } else {
      this.setState({ errorMessage: [] })
      return true
    }

  }

  hasInputFeedback = (questionTableData) => {
    const hasInputFeedback = []
    for (let i of questionTableData) {
      for (let j of i) {
        if (j.type === 'DROPDOWN') {
          if (j.hasOwnProperty('feedback') && j.feedback !== null) {
            hasInputFeedback.push(j.feedback)
          }
        }
      }
    }

    if (hasInputFeedback.length > 0) {
      return true
    } else {
      return false
    }

  }

  onReset = () => {
    this.setState({ submitDisabled: false })
  }

  closeFeedback = () => {
    this.setState({ feedbackType: null })
    this.onReset();
  }

  onCellChange = (cellChange) => {
    let { predictedAnswers } = this.state;
    const id = cellChange.id.split("_");
    const id1 = Number(id[0]);
    const id2 = Number(id[1]);
    const row = this.props.data[id1]

    predictedAnswers[id2 - 1] = row[id2].options[cellChange.value].label
    
    this.setState({ predictedAnswers });
    this.props.questionTableCellUpdate(cellChange);
  }
  
  render() {
    return (
        <div >
          <QuestionTable
            {...this.props}
            onCellChange = {this.onCellChange}
            submitAnswer = {this.onSubmitChanges}
            resetAnswer = {this.onReset}
            feedbackType={this.state.feedbackType}
            closeFeedback={this.closeFeedback}
          />
        </div>
    );
  }

}
